import { getFallbackMetadata } from '../config/seoConfig';

export function getSEOConfigForPage(pathname: string) {
  return {
    fallbackMetadata: getFallbackMetadata(pathname)
  };
}

// List of all pages that need SEO
export const PAGES_TO_UPDATE = [
  '/creators-and-influencers',
  '/retail', 
  '/freelancers',
  '/studio',
  '/agents',
  '/playbooks',
  '/visual-lab',
  '/about',
  '/contact',
  '/terms-of-use',
  '/privacy-policy'
];

// Helper to get the correct pathname for old routes
export function getCorrectPathname(pathname: string): string {
  const pathMap: Record<string, string> = {
    '/startup': '/startups',
    '/creator': '/creators-and-influencers',
    '/freelancer': '/freelancers'
  };
  
  return pathMap[pathname] || pathname;
}
